import type { RootState } from '../configure-store';

export const selectExistsInWishList = (itemId: number) => {
    return (state: RootState) => state.items?.wishListItemIds.includes(itemId);
};

export const selectWishListItemIds = (state: RootState) =>
    state.items?.wishListItemIds;
